// extracted by mini-css-extract-plugin
export default {"wrapper":"question-box_wrapper__pbjex"};